import styles from "./Index.module.scss";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import React from "react";
export function MapToolTip(props) {
  var src = "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "map_marker_stop.png");
  var hasTips = props.bloc.tipError.value.key === "locationTip";
  return /*#__PURE__*/React.createElement("div", {
    className: styles.MapToolTip,
    style: {
      background: hasTips ? "#000003D9" : "#ff4d4f"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, hasTips ? "Imagica couldn’t determine your precise location." : props.bloc.tipError.value.value), hasTips && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return props.bloc.reloadLocation();
    }
  }, "How to turn on my location?")));
}